/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/dialogs/verfuegbarkeits-check-confirm/shop.dialogs.verfuegbarkeits-check-confirm.component.ts.
 */
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

/**
 * Zweck: Beschreibt class ShopDialogsVerfuegbarkeitsCheckConfirmComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.dialogs.verfuegbarkeits-check-confirm.component.html',
    styleUrls: ['shop.dialogs.verfuegbarkeits-check-confirm.component.scss'],
    standalone: false
})
export class ShopDialogsVerfuegbarkeitsCheckConfirmComponent {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<ShopDialogsVerfuegbarkeitsCheckConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {
                titel: string,
                msg: string,
                showAlternativeArticleButton: boolean,
                showSplitAlternativeArticleButton: boolean,
                showOnlyMoeglich: boolean,
              }) {
  }


/**
 * Beschreibt Methode setResponse und ihren Rückgabevertrag.
 */
  setResponse(state: string) {
    this.dialogRef.close(state);
  }
}
